import { useIntl } from 'react-intl';

import getCarrierDisplayName from '../../../../components/data-driven-logo/get-carrier-display-name';
import getFulfillmentProviderDisplayName from '../../../../components/data-driven-logo/get-fulfillment-provider-display-name';
import getProviderDisplayName from '../../../../components/data-driven-logo/get-provider-display-name';

export const useLabelProviderDisplayName = ({ carrierId, labelProviderId, fillProviderId }) => {
  const { formatMessage } = useIntl();

  let displayName;

  if (carrierId) {
    displayName = getCarrierDisplayName(carrierId);
  } else if (labelProviderId) {
    displayName = getProviderDisplayName(labelProviderId);
  } else if (fillProviderId) {
    displayName = getFulfillmentProviderDisplayName(fillProviderId);
  }

  if (displayName) {
    return formatMessage(displayName, displayName?.values);
  }
};
